import { render, staticRenderFns } from "./ExpenseDetailsContainer.vue?vue&type=template&id=2d33aebd"
import script from "./ExpenseDetailsContainer.vue?vue&type=script&lang=js"
export * from "./ExpenseDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports